/*eslint-disable*/

import appPrince from './callApp'
import mgHttp from '../request/request'

export default {
  setCookie(name, value) {
    let Days = 30
    let exp = new Date()
    exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000)
    document.cookie =
      name + '=' + escape(value) + '; expires=' + exp.toGMTString() + '; path=/'
  },

  getCookie(name) {
    let reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)')
    let arr = document.cookie.match(reg)
    if (arr) {
      return unescape(arr[2])
    } else {
      return null
    }
  },

  removeCookie(name, domain, path) {
    document.cookie =
      name +
      '=; expires=Mon, 26 Jul 1997 05:00:00 GMT; path=' +
      (path ? path : '/') +
      '; ' +
      (domain ? 'domain=' + domain + ';' : '')
  },

  clearCookie() {
    let keys = document.cookie.match(/[^ =;]+(?=\=)/g)
    if (keys) {
      for (let i = keys.length; i--; )
        document.cookie = keys[i] + '=0;expires=' + new Date(0).toUTCString()
    }
  },

  isMGTV() {
    return /imgotv/.test(navigator.userAgent.toLowerCase()) ? true : false
  },

  isLogin() {
    if (location.href.indexOf('debug') > -1) {
      return true
    }
    return window.USERINFO.ticket && window.USERINFO.uuid
  },

  toParam(obj) {
    let result = []
    for (let key in obj) {
      result.push(key + '=' + obj[key])
    }
    return result.join('&')
  },

  getYMDHMS(value) {
    var date = new Date()
    if (value) {
      date = new Date(value)
    }
    var year = date.getFullYear()
    var month = date.getMonth() + 1
    var day = date.getDate()
    var hour = date.getHours()
    var min = date.getMinutes()
    var sec = date.getSeconds()

    return (
      '' +
      this.zeroFill(year) +
      this.zeroFill(month) +
      this.zeroFill(day) +
      this.zeroFill(hour) +
      this.zeroFill(min) +
      this.zeroFill(sec)
    )
  },

  getYMD(value) {
    var date = new Date()
    if (value) {
      date = new Date(value)
    }
    let year = date.getFullYear()
    let month = date.getMonth() + 1
    let day = date.getDate()

    return (
      this.zeroFill(year) +
      '-' +
      this.zeroFill(month) +
      '-' +
      this.zeroFill(day)
    )
  },

  //随机生成uuid
  uuid() {
    var s = []
    var hexDigits = '0123456789abcdef'
    for (var i = 0; i < 36; i++) {
      s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
    }
    s[14] = '4' // bits 12-15 of the time_hi_and_version field to 0010
    s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1) // bits 6-7 of the clock_seq_hi_and_reserved to 01
    s[8] = s[13] = s[18] = s[23] = '-'

    var uuid = s.join('')
    return uuid
  },

  rnd(m, n) {
    return Math.floor((n - m) * Math.random() + m)
  },

  isIOS() {
    const ua = navigator.userAgent.toLowerCase()

    return /(iPhone|iPad|iPod|iOS)/i.test(ua)
  },

  isAndroid() {
    const ua = navigator.userAgent.toLowerCase()

    return /(Android)/i.test(ua)
  },

  zeroFill(n) {
    return parseInt(n) < 10 ? '0' + n : n
  },

  jumpPage(url) {
    const ua = navigator.userAgent.toLowerCase()
    if (/imgotv/.test(ua) && url.indexOf('imgotv://') == -1) {
      MgtvApi.jumpPage({ url, disableEncode: '1' })
    } else {
      setTimeout(() => {
        window.location = url
      }, 300)
    }
  },

  //检查微博,微博无法唤起,显示遮罩
  checkWeibo() {
    var ua = navigator.userAgent.toLowerCase()
    let _this = this
    var isWeibo = /weibo/.test(ua)
    if (isWeibo) {
      if (!document.getElementById('weiboMask')) {
        var weiboMask = document.createElement('div')
        weiboMask.id = 'weiboMask'
        document.body.append(weiboMask)
        var weiboMaskDom = document.getElementById('weiboMask')
        weiboMaskDom.onclick = function () {
          weiboMaskDom.style.display = 'none'
        }
      } else {
        document.getElementById('weiboMask').style.display = 'block'
      }
    }
    return isWeibo
  },

  callApp(callURL) {
    if (this.checkWeibo()) {
      return false
    }
    const targetUrl = callURL || location.href
    const channelRCH = 'hitv'
    const jumpSchema = `imgotv://webview?from=${channelRCH}&url=${encodeURIComponent(
      targetUrl
    )}`

    appPrince.kiss({
      schemaUrl: jumpSchema,
      tencentUrl:
        'http://a.app.qq.com/o/simple.jsp?pkgname=com.hunantv.imgo.activity&ckey=CK1449084199069&ios_scheme=' +
        encodeURIComponent(jumpSchema) +
        '&android_schema=' +
        encodeURIComponent(jumpSchema),
      itunesUrl:
        'https://itunes.apple.com/app/apple-store/id629774477?pt=355474&ct=mg12&mt=8',
      andriodUrl: 'https://mobile.api.mgtv.com/thridGetApk?code=c103801',
      targetUrl,
    })
  },

  setWXShareInfo(params, callback) {
    const ua = navigator.userAgent.toLowerCase()
    const isWeChat = /micromessenger/.test(ua)
    const isQQ = /qq/.test(ua)

    if (isWeChat) {
      // 设置微信分享
      mgHttp({
        method: 'get',
        url: 'https://oauth.mgtv.com/weixin/sign',
        params: {
          url: location.href,
          appname: 'mgfs',
        },
      }).then((resp) => {
        this.setWxConfig(params, resp.data)
      })
    }
    if (isQQ) {
      // 设置QQ分享
      setShareInfo({
        title: params.title,
        summary: params.shareDesc,
        url: params.shareUrl || location.href,
        pic:
          params.shareIcon || 'http://i2.hitv.com/p1/20180502/1513461816.png',
      })
    }
  },
  async setWxConfig(params, data, callback) {
    if (typeof wx === 'undefined') {
      await new Promise((resolve, reject) => {
        let i;
        const interval = setInterval(() => {
          i++;
          if (typeof wx === 'object') {
            clearInterval(interval);
            resolve();
          } else if (i >= 10) {
            clearInterval(interval);
            reject('wx sdk 未加载成功!');
          }
        }, 500);
      });
    }

    wx.config({
      debug: false,
      appId: data.appId,
      timestamp: data.timestamp,
      nonceStr: data.nonceStr,
      signature: data.signature,
      jsApiList: [
        'onMenuShareTimeline',
        'onMenuShareAppMessage',
        'onMenuShareQQ',
        'onMenuShareQZone',
      ],
      openTagList: ['wx-open-launch-app'],
    })
    wx.ready(function () {
      const paramsObject = {
        type: 'link',
        title: params.title,
        desc: params.desc,
        link: params.shareUrl,
        imgUrl: params.shareIcon,
        success() {
          callback && callback()
        },
      }
      wx.onMenuShareTimeline(paramsObject)
      wx.onMenuShareAppMessage(paramsObject)
      wx.onMenuShareQQ(paramsObject)
      wx.onMenuShareQZone(paramsObject)
    })
  },
  // 跳转登录
  jumpLogin() {
    if (this.isMGTV()) {
      MgtvApi.login((resp) => {
        location.reload()
      })
    } else {
      this.removeCookie('HDCN', 'mgtv.com')
      this.removeCookie('uuid', 'mgtv.com')
      setTimeout(() => {
        window.location.href =
          'https://m.mgtv.com/login/?from=' +
          encodeURIComponent(window.location.href)
      }, 300)
    }
  },
  getUaName() {
    const ua = navigator.userAgent.toLowerCase()
    let platform = ''
    if (/iphone/.test(ua)) {
      platform = 'iphone'
    } else if (/ipad/.test(ua)) {
      platform = 'ipad'
    } else {
      platform = 'android'
    }
    return platform
  },
  preloadImg({
               imgs = [],
               webp = false,
               onStart,
               onProgress,
               onComplete,
             }) {
    let current = 0
    const total = imgs.length
    window.PRELOAD_IMG_CACHE = window.PRELOAD_IMG_CACHE || []

    onStart && onStart(total)

    const loadFunc = () => {
      current += 1
      onProgress && onProgress(current, total)

      if (current === total) {
        typeof onComplete === 'function' && onComplete(total)
      }
    }

    for (let i = 0; i < imgs.length; i++) {
      const name = imgs[i]

      // 已经预加载过的图片不再重复加载
      if (window.PRELOAD_IMG_CACHE.includes(name)) {
        loadFunc()
        continue
      }

      const img = new Image()

      img.onload = () => {
        loadFunc()
        window.PRELOAD_IMG_CACHE.push(name)
      }

      img.onerror = () => {
        loadFunc()
        console.error('preload img error:', name)
      }

      if (name.startsWith('http')) {
        img.src = webp ? Webp.addOssWebpWithImg(name) : name
      }
    }
  },
  // 判断特殊版本 不展示现金的版本：三星版、ipad、apad
  isSpecialVersion() {
    return new Promise((resolve, reject) => {
      // 方法1：通过userAgent判断
      const userAgent = navigator.userAgent.toLowerCase()
setTimeout(() => {
  console.log('userAgent', userAgent)
}, 3000)
      // 检查是否是ipad
      if (userAgent.includes('ipad')) {
        resolve(true);
      }

      // 方法2：通过SDK方法判断
      if (this.isMGTV()) {
        try {
          MgtvApi.getDeviceInfo((data) => {
            const deviceInfo = JSON.parse(data);
            setTimeout(() => {
              console.log('deviceInfo', deviceInfo)
            }, 3000)
            // 检查是否是apad
            if (deviceInfo?.apad == 1) {
              resolve(true);
            }
            
            // 检查是否是三星
            if (deviceInfo?.prech === 'samsung') {
              resolve(true);
            }

            resolve(false);
          })
          
        } catch (error) {
          console.warn('获取设备信息失败:', error)
        }
      } else {
        resolve(false)
      }
    });
  },
}
